import React from "react";
import { useTranslation } from "react-i18next";

import { updateEmailConfig } from "@admin/api/config";
import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";

type RefetchEmailConfig = () => Promise<unknown>;

export const usePutEmailConfig = (refetchEmailConfig?: RefetchEmailConfig) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const { t } = useTranslation(["pages"]);

    const onMutate = (values: API.EmailConfig) => {
        setIsLoading(true);
        void updateEmailConfig(values)
            .then(() => showSuccessToast(t("pages:adminEmailPage.toast.configUpdatedSuccess")))
            .then(() => refetchEmailConfig?.())
            .catch((error) => {
                const err = error as Error;
                showErrorToast(err.message);
            })
            .finally(() => setIsLoading(false));
    };

    return { isLoading, onMutate };
};
